import React from 'react'
import { Field as FormikField } from 'formik'

const Field = ({ name, render }) => (
  <FormikField
    name={name}
    render={({
      field,
      form: { errors, setFieldError, setFieldValue, values }
    }) =>
      render({
        ...field,
        form: { values },
        setFieldError,
        setValue: value => setFieldValue(name, value),
        error: errors[field.name],
        valid: !errors[field.name],
        renderError: () =>
          errors[field.name] ? <p>{errors[field.name]}</p> : null
      })
    }
  />
)

export default Field
